export const accordionWidth = '--accordion-width';
